import {Worker} from "../util";

export default class ObjednavkaRkCtrl {

  months = [
    "Leden", "Únor", "Březen", "Duben", "Květen", "Červen", "Červenec", "Srpen", "Září", "Říjen", "Listopad", "Prosinec"
  ];

  constructor(OdberneMiestoService, $scope){
    this.om = $scope.om;
    this.OdberneMiestoService = OdberneMiestoService;
    this.rkChart = [];
    this.rkMonthWarning = [];
    this.rkMonth = [null, null, null, null, null, null, null, null, null, null, null, null];
    this.rezPrikon = parseFloat(this.om.rezervovanyPrikonMW);
    this.rkYear = parseFloat(this.om.rkRocnaMW);
    var now = new Date();
    this.updateChart();
    this.datumZahajeniaDistribucie =  new Date(now.getFullYear(), now.getMonth()+1, 1);
    this.save = Worker(this._save);
    this.month = (new Date().getMonth() + 1) % 12;
    this.oneMonth = true;
    this.rok = this.datumZahajeniaDistribucie.getFullYear();
  }


  updateChart(){
    var max = this.rezPrikon;
    for(var i=0; i<12; i++){
      var sum = this.rkYear + (this.rkMonth[i]||0);
      this.rkMonthWarning[i] = (sum > max);
      if(this.rkMonth[i] !== null){
        this.rkChart[i] = 100*(sum / max);
      }else{
        this.rkChart[i] = null;
      }
    }
  }

  _save(){
    var zmenaRk = {
      om: { id: this.om.id },
      datumZahajeniaDistribucie: this.datumZahajeniaDistribucie,
      rkRocnaMW: this.rkYear,
      rkMesacnaMW: this.rkMonth
    };
    return this.OdberneMiestoService.orderRk(zmenaRk);
  }


}


// WEBPACK FOOTER //
// ./src/RezervovanaKapacita/ObjednavkaRkCtrl.js